



import { defineComponent, ref } from '@vue/composition-api'
import Accordion from '~/components/Accordion/Accordion.vue';
import { AccordionItemType } from "~/utils/types";
export default defineComponent({
    components:{
        Accordion
    },
    props:{
        content:{
            type: String,
            required: true
        }
    },
    setup(props){
        const accordionItems = ref<AccordionItemType[]>([{title: 'Extract', content: props.content} as AccordionItemType]);
        return {accordionItems};
    },
    methods:{
        getAccordionItems(){
            return [{title:this.$nuxt.$t('Extract'), content: this.content} as AccordionItemType]
        }
    }
})
